import React from "react";

import ColorControl from "../ui/ColorControl";

export default function GoochControls({
  Slider,

  coolColor,
  setCoolColor,

  warmColor,
  setWarmColor,

  coolMix,
  setCoolMix,

  warmMix,
  setWarmMix,
}) {
  return (
    <>
      <ColorControl
        label="Cool Color"
        value={coolColor}
        onChange={setCoolColor}
      />

      <ColorControl
        label="Warm Color"
        value={warmColor}
        onChange={setWarmColor}
      />

      <Slider
        label="Cool Mix"
        value={coolMix}
        min={0}
        max={1}
        step={0.01}
        display={coolMix.toFixed(2)}
        onChange={setCoolMix}
      />

      <Slider
        label="Warm Mix"
        value={warmMix}
        min={0}
        max={1}
        step={0.01}
        display={warmMix.toFixed(2)}
        onChange={setWarmMix}
      />
    </>
  );
}
